import { apiClient, retryRequest } from './httpClient';

// Generic API request wrapper with retry functionality
export async function apiRequest(endpoint, method = "GET", data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: method.toUpperCase(),
        ...options
    };

    if (data) {
        if (method.toUpperCase() === 'GET') {
            requestConfig.params = data;
        } else {
            requestConfig.data = data;
        }
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'API request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = method;
        throw err;
    }
}

// Convenience methods for different HTTP verbs
export const api = {
    get: (endpoint, params = null, options = {}) => 
        apiRequest(endpoint, 'GET', params, options),
    
    post: (endpoint, data = null, options = {}) => 
        apiRequest(endpoint, 'POST', data, options),
    
    put: (endpoint, data = null, options = {}) => 
        apiRequest(endpoint, 'PUT', data, options),
    
    patch: (endpoint, data = null, options = {}) => 
        apiRequest(endpoint, 'PATCH', data, options),
    
    delete: (endpoint, options = {}) => 
        apiRequest(endpoint, 'DELETE', null, options)
};